import { render, staticRenderFns } from "./LayAuthor.vue?vue&type=template&id=d4dfad9a&scoped=true&"
import script from "./LayAuthor.vue?vue&type=script&lang=js&"
export * from "./LayAuthor.vue?vue&type=script&lang=js&"
import style0 from "./LayAuthor.vue?vue&type=style&index=0&id=d4dfad9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dfad9a",
  null
  
)

export default component.exports